// extracted by mini-css-extract-plugin
export default {"container":"EditPane_container__Sgpnj","content":"EditPane_content__M6liU","footer":"EditPane_footer__X2+WV","nameField":"EditPane_nameField__kVseJ"};